import { applicationInsights } from '../../ApplicationInsights';

export const logApplicationInsightsEvent = (name: string, customProperties?: object) => {
    if (import.meta.env.DEV) return;

    if (customProperties) {
        applicationInsights.appInsights.trackEvent({ name }, customProperties);
    } else {
        applicationInsights.appInsights.trackEvent({ name });
    }
};

export const logApplicationInsightsTrace = (message: string, customProperties?: object) => {
    if (import.meta.env.DEV) return;

    if (customProperties) {
        applicationInsights.appInsights.trackTrace({ message }, customProperties);
    } else {
        applicationInsights.appInsights.trackTrace({ message });
    }
};

export const logApplicationInsightsError = (error: Error) => {
    if (import.meta.env.DEV) return;

    applicationInsights.appInsights.trackException({ exception: error });
};
